import { ref, watch, computed, onMounted } from "@vue/composition-api";
import store from "@/store";

export default function useDedicatedFundList() {

  const refDedicatedFundListTable = ref(null);

  const dedicatedFundFields = [
    {
      key: "id",
      label: "Id",
    },
    { key: "label", label: "Désignation", sortable: true },
    { key: "credit", label: "Déduction reçue", sortable: true },
    { key: "debit", label: "Transfert", sortable: true },
    { key: "balance", label: "Solde" },
    // { key: "project", label: "Projet Concerné" },
    { key: "made_by", label: "Effectuée Par", sortable: true },
    { key: "created_at", label: "Date", sortable: true },
  ];


  //dedicated fund pagination & filter params
  const dfPerPage = ref(5);
  const dfCurrentPage = ref(1);
  const dfPageOptions = ref([5, 10, 15, 20]);
  const dfFilter = ref("");
  const dfSortBy = ref("created_at");
  const dfSortDesc = ref(false);
  const dfSortDirection = ref("asc");

  const dedicatedFundList = computed(() => store.state.dedicatedFund.transacHistories);
  const totalDebitAndCredit = computed(() => store.getters["dedicatedFund/transacs"]);
  const totalDedicatedFundList = computed(() => store.getters["dedicatedFund/total"]);

  const deductedFundAmountDetails = computed(() => {
    return {
      requests_total: 0,
      budgets_total: 0,
    };
  });

  const refetchDfData = () => {
    refDedicatedFundListTable.value.$refs.refListTable.refresh();
  };

  // Refetch all funds histories data
  const refetchData = () => {
    fetchDedicatedFund()
    refetchDfData() //dedicated fund list
  }

  watch([dfCurrentPage, dfPerPage], () => {
    refetchDfData();
  });

  const fetchDedicatedFund = async () => {
    await store.dispatch("dedicatedFund/fetchDedicatedFund");
  }

  onMounted(() => {
    fetchDedicatedFund();
  })

  const getDedicatedFundHistories = (ctx, callback) => {
    store.dispatch("dedicatedFund/fetchTransacHistories", {
      filter: ctx.filter,
      perPage: ctx.perPage,
      page: ctx.currentPage,
      type: 'dedicated-fund',
    }).then(() => {
      callback(dedicatedFundList.value)
    });
  };


  return {
    getDedicatedFundHistories,
    refetchData,
    dedicatedFundFields,

    //dedicated fund query properties
    dfPerPage,
    dfPageOptions,
    dfCurrentPage,
    dfSortBy,
    dfSortDesc,
    dfSortDirection,
    dfFilter,

    totalDedicatedFundList,
    refDedicatedFundListTable,
    totalDebitAndCredit,

    deductedFundAmountDetails,
  };
}
